module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title) + "\n      "), _c('a', {
    staticClass: "button is-success is-pulled-right",
    on: {
      "click": _vm.newContact
    }
  }, [_vm._v("\n        New Contact\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Contacts")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.contacts.length > 0) ? _vm._l((_vm.contacts), function(contact) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.parseType(contact.type, contact.other)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'tel:' + contact.phone
      }
    }, [_vm._v(_vm._s(contact.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contact.phone_extension))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": 'mailto:' + contact.email
      }
    }, [_vm._v(_vm._s(contact.email))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(contact.responsible))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(parseInt(_vm.context.$store.state.config.user.level) === 3) ? _c('a', {
      staticClass: "button button-table is-small",
      on: {
        "click": function($event) {
          return _vm.excludeContact(contact.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e(), _vm._v(" "), (parseInt(_vm.context.$store.state.config.user.level) <= 3 || parseInt(contact.type) === 4) ? _c('a', {
      staticClass: "button button-table is-small",
      on: {
        "click": function($event) {
          return _vm.editContact(contact.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()])])
  }) : [_vm._m(1)]], 2)])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Phone")]), _vm._v(" "), _c('th', [_vm._v("Extension")]), _vm._v(" "), _c('th', [_vm._v("E-Mail")]), _vm._v(" "), _c('th', [_vm._v("Responsible")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No contacts")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ee5dd0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/customer/Contacts.vue
// module id = 1132
// module chunks = 39